import {
    ThemeFontSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library.base-ui.theme";
import { Box } from "@caspeco/casper-ui-library.components.box";
import { Grid } from "@caspeco/casper-ui-library.components.grid";
import { Skeleton } from "@caspeco/casper-ui-library.components.skeleton";
import { Stack } from "@caspeco/casper-ui-library.components.stack";

interface ISelectGuestsSkeletonProps {
    maxGuests?: number;
    showAlert?: boolean;
}

const SelectGuestsSkeleton = ({ maxGuests = 8 }: ISelectGuestsSkeletonProps) => {
    return (
        <>
            {/* Header skeleton */}
            <Skeleton
                height={ThemeFontSizeVariable.X2Large}
                width="60%"
                mb={ThemeSpaceVariable.Medium}
            />

            {/* Introduction text skeleton */}
            <Stack mt={ThemeSpaceVariable.Medium} mb={ThemeSpaceVariable.Large}>
                <Skeleton height={ThemeFontSizeVariable.Medium} width="90%" />
                <Skeleton height={ThemeFontSizeVariable.Medium} width="75%" />
                <Skeleton height={ThemeFontSizeVariable.Medium} width="85%" />
            </Stack>

            {/* Guest selection buttons grid */}
            <Box width="100%">
                <Grid templateColumns="repeat(4, 1fr)" gap={ThemeSpaceVariable.Medium} width="100%">
                    {Array.from({ length: Math.min(maxGuests, 8) }).map((_, index) => (
                        <Skeleton
                            key={index}
                            height={ThemeSpaceVariable.XLarge}
                            width="100%"
                            borderRadius={ThemeSpaceVariable.Small}
                        />
                    ))}
                </Grid>
            </Box>
        </>
    );
};

export default SelectGuestsSkeleton;
